module.exports = __webpack_public_path__ + "0d902c72788b88512f74316ea72886a4.jpg";